import { AccountInfo } from '@azure/msal-browser';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { publicClientApplication, scopes } from './App';

const baseURL = '/api/';

let testing_force401: boolean = false;

export function testing_setForce401(value: boolean) {
  console.log(` ⚠️ Setting testing_force401 to ${value}`);

  testing_force401 = value;
}

export function testing_getForce401(): boolean {
  console.log(` ⚠️ Getting testing_force401: ${testing_force401}`);

  return testing_force401;
}

export const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  async config => {
    let accountInfo: AccountInfo | null = null;
    let tokenResponse = await publicClientApplication.handleRedirectPromise();

    if (tokenResponse) {
      accountInfo = tokenResponse.account;
    } else {
      accountInfo = publicClientApplication.getAllAccounts()[0];
    }

    if (accountInfo && tokenResponse) {
      // Intentionally empty
    } else if (accountInfo) {
      try {
        try {
          tokenResponse = await publicClientApplication.acquireTokenSilent({
            account: accountInfo ?? undefined,
            scopes
          });
        } catch {
          await publicClientApplication.acquireTokenRedirect({ scopes });
        }
      } catch {
        await publicClientApplication.loginRedirect({ scopes });
      }
    } else {
      await publicClientApplication.loginRedirect({ scopes });
    }

    config.headers.Authorization = `Bearer ${tokenResponse?.idToken /* accessToken */}`;

    if (testing_force401 === true) {
      config.headers.Authorization = `Bearer `;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 401) {
      sessionStorage.clear();
      localStorage.clear();
      publicClientApplication.loginRedirect({ scopes, prompt: 'select_account' });

      // publicClientApplication.loginRedirect({ scopes });
      // publicClientApplication.logoutRedirect();
      // window.location.reload();
    } else if (error?.response?.data?.message) {
      enqueueSnackbar(error.response.data.message, { variant: 'error' });
    }

    throw error;
  }
);
